import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { DashboardContent } from '@/layouts/dashboard';
import { TiaBanner } from '@/components/custom/tia-banner';
import { HeroLevelCard } from '@/pages/dashboard/home/hero-level-card';
import tiaIdeia from '@/assets/images/tia/TIA-IDEIA.png';
import { QuestionCardPlayful } from './QuestionCardPlayful';
import { SidebarPlayful } from './SidebarPlayful';

function ExercisesQuestionsPlayful({ uri, id }) {
  const navigate = useNavigate();
  const client = useClient();
  const [book, setBook] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [lastAnswerSubmitted, setLastAnswerSubmitted] = useState(null);

  useEffect(() => {
    const fetchBook = async () => {
      const { data, error } = await client.fetch(`question_books/${id}`);
      if (!error) setBook(data);
    };

    const fetchQuestions = async () => {
      const { data, error } = await client.fetch(`questions?filter[question_book_id]=${id}&page[size]=100`);
      if (error) toast.error('Não foi possível carregar as questões.');
      else setQuestions(data || []);
    };

    fetchBook();
    fetchQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const breadcrumbs = {
    title: 'Exercícios',
    nav: [
      { route: '/questions/apostilas', name: 'Exercícios', isActive: false },
      { route: uri, name: book?.title, isActive: true }
    ]
  };

  const handleAnswer = async (question, alternativeId) => {
    const { data, error } = await client.mutate('answers', { 'alternative-id': alternativeId, 'question-id': question.id });
    if (error) {
      toast.error(error.title || 'Não foi possível enviar sua resposta.');
      return;
    }
    setAnswers(prev => ({ ...prev, [question.id]: data }));
    setLastAnswerSubmitted(data.id);
  };

  const handleAddComment = async (question, text) => {
    const { data, error } = await client.mutate('comments', { body: text, question_id: question.id });
    if (error) {
      toast.error('Não foi possível enviar o comentário.');
      return;
    }
    setQuestions(prev => prev.map(q => (q.id === question.id ? { ...q, comments: [...(q.comments || []), data] } : q)));
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <div className="mb-6 flex flex-col gap-4 md:mt-16 md:flex-row md:items-stretch">
        <TiaBanner
          className="flex-1"
          image={tiaIdeia}
          text="Foco total, você consegue! 💪"
        />

        <div className="md:w-[380px] md:shrink-0">
          <HeroLevelCard />
        </div>
      </div>

      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-[1fr_380px]">
        <div className="space-y-4">
          {questions.map(question => (
            <QuestionCardPlayful
              key={question.id}
              question={question}
              answer={answers[question.id]}
              onAnswer={alternativeId => handleAnswer(question, alternativeId)}
              onAddComment={text => handleAddComment(question, text)}
            />
          ))}
        </div>

        <SidebarPlayful
          book={book}
          answeredCount={Object.keys(answers).length}
          totalCount={questions.length}
          lastAnswerSubmitted={lastAnswerSubmitted}
          onExit={() => navigate('/questions/apostilas')}
        />
      </div>
    </DashboardContent>
  );
}

export default ExercisesQuestionsPlayful;
